export { default, Detached } from './OpportunityTab';
